import React, { useEffect, useRef, useState } from "react";
import { getSetting } from "../../../../utils/frontendSettingsManager";
import HideSomeInfo from "../../../elements/hideSomeInfo/HideSomeInfo";
import MaterialPagination from "../../../styles/materialPagination";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import axios from "axios";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { useHistory } from "react-router-dom";
import Notification from "../../../elements/notification/Notification";
import BalancesFilter from "./BalancesFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import BalancesList from "../../../elements/balances/BalancesList";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import { parseAxiosError } from "../../../../utils/response";
import { frontendSettings, HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";
import { useTranslation } from "react-i18next";

const BalancesContainer = ({ match }) => {
  const { t } = useTranslation("accountPage");

  const [balances, setBalances] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);
  const [hideZeroBalances, setHideZeroBalances] = useState(getSetting(frontendSettings.hideZeroClientBalancesAdmin) ?? false);
  const hideZeroBalancesRef = useRef();
  hideZeroBalancesRef.current = hideZeroBalances;

  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "balances", false, true),
    "currency.asset": checkFilterItem(history, "currency.asset", null),
    "service.name": checkFilterItem(history, "service.name", null),
    "amount[gte]": checkFilterItem(history, "amount[gte]", null, true),
    "amount[lte]": checkFilterItem(history, "amount[lte]", null, true)
  });

  useEffect(() => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    if (hideZeroBalancesRef.current) {
      filterUrl += `&${frontendSettings.hideZeroBalances}=true`;
    }

    axios.get("/api/balances" + filterUrl + "&user.id=" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setBalances(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }, [filterData, hideZeroBalances]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <div className="content-head">
        <BalancesFilter
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <ItemsPerPageSelect
          itemsPerPage={filterData.itemsPerPage}
          setItemsPerPage={(data) => setFilterData({
            ...filterData,
            "itemsPerPage": data,
            page: 1
          })}
        />
        <HideSomeInfo
          data={hideZeroBalances}
          setData={setHideZeroBalances}
          name={frontendSettings.hideZeroClientBalancesAdmin}
          label={t("balances.filter.hideZeroBalances")}
        />
      </div>
      <FilterAppliedList
        filterData={filterData}
        setFilterData={setFilterData}
      />
      <BalancesList balances={balances} />
      {totalPageCount > 1  &&
      <MaterialPagination
        count={totalPageCount}
        shape="rounded"
        page={filterData.page}
        onChange={(event, page) => onChangePage(event, page)}
      />}
    </>
  );
};

export default BalancesContainer;